<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-card v-if="guideLine != null && guideLine.isVisible" outlined class="pb-1">
        <v-toolbar dense flat>
            <v-spacer />
            <v-btn icon @click="onClickPreviousData" color="primary">
                <v-icon>mdi-chevron-left-circle</v-icon>
            </v-btn>
            <h3>{{guideLine.x}}</h3>
            <v-btn icon @click="onClickNextData" color="primary">
                <v-icon>mdi-chevron-right-circle</v-icon>
            </v-btn>
            <v-spacer />
        </v-toolbar>
        <v-divider class="mb-2" />
        <!-- <v-chip v-for="(value, index) in values" :key="index" class="mr-1 ml-1 mb-1" label>
            {{value.sensor.body.name}}:{{value.value}}{{value.sensor.body.unit}}
        </v-chip> -->
        <v-container fluid class="pa-0">
            <v-row class="pl-3 pr-3">
                <v-sheet v-for="(value, index) in values" :key="index" class="mr-1 ml-1 mb-1 pa-1" outlined>
                    <table>
                        <tr>
                            <td style="text-align:center">{{value.sensor.body.name}}</td>
                        </tr>
                        <tr>
                            <td style="text-align:center" class="indigo darken-4 white--text pa-1"><h2>{{value.value.toFixed(1)}}{{value.sensor.body.unit}}</h2></td>
                        </tr>
                    </table>
                </v-sheet>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
    export default {
        props: {
            /** ガイドライン */
            guideLine: null
        },
        data: function () {
            return {
            }
        },
        computed: {
            /**
             * 一覧に表示するデータを格納した配列
             */
            values: function () {
                const list = []
                if (this.guideLine == null || this.guideLine.isVisible == false) {
                    return list
                }
                const chartData = this.guideLine.chart.getChartData()
                const measureDatasets = chartData.data.datasets.filter((v)=>v.additionalData != null && v.additionalData.type == "measure_dataset")
                if (measureDatasets.length == 0) {
                    return list
                }
                const self = this
                measureDatasets.forEach(function(dataset){
                    const targetValue = dataset.data.find((v)=>v.x == self.guideLine.x)
                    if (targetValue != null) {
                        list.push(
                            {
                                value: targetValue.y,
                                sensor: targetValue.additionalData.sensor
                            }
                        )
                    } else {
                        console.log("ChartSelectPositionValues", "values", "data none", self.guideLine.x, dataset.additionalData.sensor.body.sensorKey)
                    }
                })
                return list
            }
        },
        methods: {
            /**
             * 前データボタン押下時
             */
            onClickPreviousData: function () {
                const chartData = this.guideLine.chart.getChartData()
                const measureDatasets = chartData.data.datasets.filter((v)=>v.additionalData != null && v.additionalData.type == "measure_dataset")
                if (measureDatasets.length == 0) {
                    return
                }
                var nextX = null
                for (var dataset of measureDatasets) {
                    const dataList = dataset.data.filter((v)=>v.x < this.guideLine.x)
                    if (dataList.length > 0) {
                        if (nextX == null || nextX < dataList[dataList.length - 1]) {
                            nextX = dataList[dataList.length - 1].x
                        }
                    }
                }
                if (nextX != null) {
                    console.log("next", nextX)
                    this.guideLine.x = nextX
                }
            },
            /**
             * 次データボタン押下時
             */
            onClickNextData: function () {
                const chartData = this.guideLine.chart.getChartData()
                const measureDatasets = chartData.data.datasets.filter((v)=>v.additionalData != null && v.additionalData.type == "measure_dataset")
                if (measureDatasets.length == 0) {
                    return
                }
                var nextX = null
                for (var dataset of measureDatasets) {
                    const dataList = dataset.data.filter((v)=>v.x > this.guideLine.x)
                    if (dataList.length > 0) {
                        if (nextX == null || nextX > dataList[0]) {
                            nextX = dataList[0].x
                        }
                    }
                }
                if (nextX != null) {
                    console.log("next", nextX)
                    this.guideLine.x = nextX
                }
            },
        }
    }
</script>
